// @flow
import { type ComponentType } from "react";
import { type State } from "./ducks";
import { type BackButtonProps } from "../BackButton";

type URLpath = string;

type NextOptions = {
  prefilled?: boolean,
};

export type ValidationErrors = {
  [string]: string,
};

export type ActionButtonsProps = {
  skippable?: boolean,
  skip?: NextFunction<any>,
};

export type FormField<T> = $ElementType<State, T>;

export type NextFunction<T> = (
  value: FormField<T>,
  validator?: (value: FormField<T>) => Promise<ValidationErrors>,
  options?: NextOptions,
) => any;

export type QuestionProps<T: $Keys<State>> = {|
  ActionButtons: React$ComponentType<ActionButtonsProps>,
  BackButton: React$ComponentType<BackButtonProps>,
  initialValue?: $ElementType<State, T>,
  next: NextFunction<T>,
  submitError?: React$Node,
  valid: boolean,
  validationErrors: ValidationErrors,
  descriptionCopy?: string,
  updateFormState: ($Shape<State>) => void,
|};

type QuestionInputProps<T> = {|
  name: T,
  component: ComponentType<QuestionProps<T>>,
  route: URLpath,
  skip?: (state: State) => boolean,
|};

// Best effort typing here
export const Question: (props: QuestionInputProps<*>) => null = () => null;
